// extracted by mini-css-extract-plugin
module.exports = {"cls1":"StyledComponents-BackgroundContainer_cls1__1mJp6","cls2":"StyledComponents-BackgroundContainer_cls2__1Ph0G StyledComponents-BackgroundContainer_cls1__1mJp6"};